const Rocket02 = ({
  color = 'currentColor',
  width = 21,
  height = 20,
}: {
  color?: string
  width?: number
  height?: number
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M10.5004 12.5L8.00041 10M10.5004 12.5C11.6644 12.0573 12.7811 11.499 13.8337 10.8334M10.5004 12.5V16.6667C10.5004 16.6667 13.0254 16.2084 13.8337 15C14.7337 13.65 13.8337 10.8334 13.8337 10.8334M8.00041 10C8.44386 8.84957 9.00224 7.74676 9.66707 6.70838C10.6381 5.15587 11.9901 3.87758 13.5946 2.99512C15.1991 2.11266 17.0026 1.65535 18.8337 1.66671C18.8337 3.93338 18.1837 7.91671 13.8337 10.8334M8.00041 10H3.83374C3.83374 10 4.29207 7.47504 5.50041 6.66671C6.85041 5.76671 9.66707 6.66671 9.66707 6.66671M4.25041 13.75C3.00041 14.8 2.58374 17.9167 2.58374 17.9167C2.58374 17.9167 5.70041 17.5 6.75041 16.25C7.34207 15.55 7.33374 14.475 6.67541 13.825C6.3515 13.5159 5.92482 13.3372 5.47726 13.3234C5.02971 13.3096 4.5928 13.4615 4.25041 13.75Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Rocket02
